module.exports = __webpack_public_path__ + "static/media/BenProf.76698077.jpeg";